import React from "react";

const holder = {
  closeDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeDropdownSelector)
    }
  }
};

export default {
  'Dropdown.Selector': async ({ isOpen, containerRef, headerRef }, _, internalStateSetter) => {

    let newContainerRef = containerRef;
    let newHeaderRef = headerRef;

    if (!containerRef || !headerRef) {
      newContainerRef = React.createRef(null);
      newHeaderRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, headerRef: newHeaderRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    internalStateSetter('isOpen', !isOpen);
    internalStateSetter('searchTerm', '');

    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
  'Dropdown.Body.Search': ({ value }, _, internalStateSetter) => {
    internalStateSetter('searchTerm', value)
  },
  'Dropdown.Selector.Icons.Clear': ({ }, outlet) => {
    outlet({ selectedOptionId: null })
  },
  'Dropdown.Body.Options.Option': ({ option, selectedOptionId }, outlet, internalStateSetter) => {
    if (selectedOptionId !== option.id) {
      outlet({ selectedOptionId: option.id })
      internalStateSetter('isOpen', false);
    }
  }
}